import {
  Box,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { FaTruck } from "react-icons/fa";
import { FiCalendar, FiMap, FiUser } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Table from "../components/Table";
import { orderDetailsColumns } from "../data/OrderDetails";
import { joinObjectPropertiesWithComma } from "../utilities/common";

const SingleProduct = () => {
  const { id } = useParams();
  const orders = useSelector((state) => state.order.orderDetails);
  const order = orders.find((order) => order._id === id);

  const { customer, order_date, status, items, paymentMethod, securityAnswer } =
    order;
  const { firstName, lastName, email, phone, shippingAddress, _id } = customer;

  return (
    <Box sx={{ pt: "80px", pb: "20px" }}>
      <Paper
        sx={{
          boxShadow: "none !important",
          borderRadius: "12px",
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: "divider",
          p: "20px",
        }}
      >
        <Typography variant="h5">Order details</Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ my: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FiCalendar />
              <Typography variant="h6">{order_date}</Typography>
            </Box>
            <Typography variant="subtitle2" sx={{ opacity: 0.7, pb: 1 }}>
              Order ID #{order._id}
            </Typography>
          </Box>
          <Box>
            <span
              style={{
                padding: "3px 10px",
                borderRadius: "5px",
                textDecoration: "none",
              }}
              className={status}
            >
              {status}
            </span>
          </Box>
        </Box>
        <Divider />
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box>
                <IconButton
                  sx={{
                    color: "#049bf5",
                    backgroundColor: "rgba(4,155,245, 0.2) !important",
                  }}
                >
                  <FiUser />
                </IconButton>
              </Box>
              <Box>
                <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                  Customer
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Name:{" "}
                  <span
                    style={{ opacity: 0.7 }}
                  >{`${firstName} ${lastName}`}</span>
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Email: <span style={{ opacity: 0.7 }}>{email}</span>
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Phone: <span style={{ opacity: 0.7 }}>{phone}</span>
                </Typography>
                <Link
                  to={`/customers/${_id}`}
                  style={{
                    padding: "3px 10px",
                    color: "#049bf5",
                    backgroundColor: "rgba(4, 155, 245,0.2)",
                    borderRadius: "5px",
                    textDecoration: "none",
                  }}
                >
                  View Profile
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box>
                <IconButton
                  sx={{
                    color: "#049bf5",
                    backgroundColor: "rgba(4,155,245, 0.2) !important",
                  }}
                >
                  <FaTruck />
                </IconButton>
              </Box>
              <Box>
                <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                  Order Info
                </Typography>
                {/* <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Shipping: <span style={{ opacity: 0.7 }}>Forgo express</span>
                </Typography> */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Payment Method:{" "}
                  <span style={{ opacity: 0.7 }}>{paymentMethod}</span>
                </Typography>

                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Status: <span style={{ opacity: 0.7 }}>{status}</span>
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box>
                <IconButton
                  sx={{
                    color: "#049bf5",
                    backgroundColor: "rgba(4,155,245, 0.2) !important",
                  }}
                >
                  <FiMap />
                </IconButton>
              </Box>
              <Box>
                <Typography variant="h6" sx={{ fontSize: "20px", mb: 2 }}>
                  Delivery
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: "15px", mb: 2 }}
                >
                  Address:{" "}
                  <span style={{ opacity: 0.7 }}>
                    {joinObjectPropertiesWithComma(shippingAddress, [
                      "address1",
                      "city",
                      "postalCode",
                    ])}
                  </span>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Products details
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Table
            data={items}
            fields={orderDetailsColumns}
            numberOfRows={items.length}
            enableTopToolBar={false}
            enableBottomToolBar={false}
            enablePagination={false}
            enableRowSelection={false}
            enableColumnFilters={false}
            enableEditing={false}
            enableColumnDragging={false}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default SingleProduct;
